/**
 * Caixa-only tracking events, described in tracking-catalog.ts next to this file
 */
export enum CAIXA_TRACKING_MODELS {
  // Navigation bar
  navigateMyFinance = 'act_navigate_my_finance_caixa',
  openHelp = 'act_open_help_caixa',
  connectAccountsOpenFinance = 'act_connect_accounts_open_finance_caixa',

  // Statement
  recordListSearchCaixa = 'act_record_list_search_caixa',

  // Credit lines
  creditLinesView = 'act_credit_lines_view_caixa',
  creditLinesTabChange = 'act_credit_lines_tab_change_caixa',
  creditLinesSort = 'act_credit_lines_sort_caixa',
  creditLinesOpenDetails = 'act_credit_lines_open_details_caixa',

  // Investments
  investmentsView = 'act_investments_view_caixa',
  investmentsTabChange = 'act_investments_tab_change_caixa',
  investmentsSort = 'act_investments_sort_caixa',
  investmentsOpenDetails = 'act_investments_open_details_caixa',
}
